import { render, staticRenderFns } from "./ArticleElement.vue?vue&type=template&id=21c6824c&scoped=true&"
import script from "./ArticleElement.vue?vue&type=script&lang=js&"
export * from "./ArticleElement.vue?vue&type=script&lang=js&"
import style0 from "./ArticleElement.vue?vue&type=style&index=0&id=21c6824c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c6824c",
  null
  
)

export default component.exports